export default "/images/9b34f8cf46329b404141e514abd52171.avif";